import { Bug, ShieldCheck, Timer, Wallet } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function ChimneyRepairService() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Cockroach Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        Our professional cockroach control treatment is totally proven, odorless and non-messy, giving you long-lasting protection against cockroach infestation at home or in your business.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Step One: Gel Application - we apply high-quality roach gel at strategic points where cockroaches hide and breed.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Step Two: Odorless Spray - a depth odorless liquid spray treatment eliminates remaining cockroach population and their nests.
                    </p>
                    <p className="chimney-repair-subtitle">
                        The treatment is highly convenient for customers - our services can be executed without any disturbance to the routine work in your house.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="Cockroach Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Cockroach Control?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Bug size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Proven & Effective</h3>
                            <p className="chimney-repair-description">
                                Totally proven treatment that is odorless, non-messy and long lasting.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Safety First</h3>
                            <p className="chimney-repair-description">
                                Best in class environmentally safe active ingredients for your family and pets.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Timer size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">No Disturbance</h3>
                            <p className="chimney-repair-description">
                                Convenient treatment without any disturbance to your routine home work.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Wallet size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Cost Effective</h3>
                            <p className="chimney-repair-description">
                                Professional, eco-friendly and pocket friendly pest control solution.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Cockroach Control Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Free Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Our trained team conducts a detailed inspection of your premises to identify cockroach hides and the extent of infestation.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Gel Application</h3>
                        <p className="chimney-repair-step-description">
                            Targeted application of proven gel at infested areas where cockroaches feed, nest and breed.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Odorless Spray</h3>
                        <p className="chimney-repair-step-description">
                            Specialized odorless spray treatment completes the elimination of all cockroach population.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Preventive Advice</h3>
                        <p className="chimney-repair-step-description">
                            We explain the pre and post service requisites so you can keep the premises pest free for longer.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default ChimneyRepairService;